/**
 * Record Audio Element
 */

import type { ElementDefinition } from '@ai-content-hub/content-kit';
import { recordAudioElementSchema, type RecordAudioElementData } from './schema';
import { RecordAudioEdit } from './RecordAudioEdit';
import { RecordAudioPlayer, type RecordAudioAnswer } from './RecordAudioPlayer';

export { recordAudioElementSchema, type RecordAudioElementData };
export { RecordAudioEdit };
export { RecordAudioPlayer, type RecordAudioAnswer };

export const recordAudioElement: ElementDefinition<RecordAudioElementData, RecordAudioAnswer> = {
    schema: recordAudioElementSchema,
    EditComponent: RecordAudioEdit as any,
    PlayerComponent: RecordAudioPlayer as any,
};
